import { render, staticRenderFns } from "./MonthlyCustomerPayment.vue?vue&type=template&id=628a4854"
import script from "./MonthlyCustomerPayment.vue?vue&type=script&lang=js"
export * from "./MonthlyCustomerPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports